/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule printRelayQuery
 */

'use strict';

module.exports = require('./printRelayOSSQuery');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-relay/lib/printRelayQuery.js
 ** module id = 158
 ** module chunks = 0
 **/